import React from 'react';

import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';

import { Layout, Flex } from 'antd';
import HeaderPortal from '../../layout/header/HeaderPortal';
import { ProjectsList } from './ProjectsList';
import AddButton from 'components/action/AddButton';
import Loader from 'components/Loading/Loader';
import ProjectModal from 'components/Modal/ProjectModal';
import { useProjectController } from 'hooks/useProjectController';
import WaitModal from 'components/Modal/WaitModal';

import {
	useCreateProjectMutation,
	useListProjectsQuery
} from '../../graphql/generated';

import './Projects.sass';


export const Projects = (props: any) => {
	const [editedItem, setEditedItem] = React.useState<any | null>(null);
	const [createProject] = useCreateProjectMutation();
	const { cloneProject, deleteProject } = useProjectController();
	const { data, refetch, loading } = useListProjectsQuery();
	const { t } = useTranslation();
	let history = useHistory();

	const handleCreateProject = async (values: any) => {
		const result = await createProject({
			variables: {
				...values,
			},
		});
		await refetch();
		history.push('/projects/' + result?.data?.createProject?.id);
	};

	const handleCloneProject = async (id: string) => {
		setTimeout(() => props.pushModal(<WaitModal></WaitModal>), 100);
		await cloneProject(id);
		props.popModal();
		await refetch();
	}

	const handleDeleteProject = async (id: string) => {
		await deleteProject(id);
		await refetch();
	}

	const handleSelectProject = async (projectId: any) => {
		console.log('handleSelectProject', projectId);
		if (props.modals && props.modals.length > 0) return;
		history.push('/projects/' + projectId);
	};

	return (
		<Layout className="Projects">
			<HeaderPortal>{t('models.project.my_xs')}</HeaderPortal>

			<Layout.Content className="pt-2 pb-2">
				{loading ? (
					<Loader></Loader>
				) : (
					<>
						<ProjectsList
							pushModal={props.pushModal}
							popModal={props.popModal}
							onSelectProject={handleSelectProject}
							canClone={true}
							onClone={handleCloneProject}
							refetch={refetch}
							onDelete={handleDeleteProject}
							list={data?.listProjects?.items || []}
						></ProjectsList>
						<div className="footer mr-auto ml-auto" style={{ width: "90%" }}>
							<AddButton
								onClick={() => {
									setEditedItem({});
								}}
							></AddButton>
						</div>
					</>
				)}

				{editedItem !== null && (
					<ProjectModal
						onHide={() => {
							setEditedItem(null);
						}}
						onSave={(values: Object) => {
							handleCreateProject(values);
							setEditedItem(null);
						}}
						id={editedItem?.id}
						values={{
							name: editedItem?.name,
							context: editedItem?.context,
							description: editedItem?.description,
							experienceLevel: editedItem?.experienceLevel || 2,
						}}
					></ProjectModal>
				)}
			</Layout.Content>
		</Layout>
	);
};
